import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Servico } from '../../../../types/Servico.type';
import { ProcessoServico } from '../../../../types/ProcessoServico.type';

@Injectable({
  providedIn: 'root'
})
export class ServicosService {

  constructor(private configService: ConfigService, private httpClient: HttpClient) { }

  getServicos(processos: ProcessoServico[]){
      return this.httpClient.post<Servico[]> (`${this.configService.getApiUrlRoot()}/servicos/`, processos)
  }
  
  buscarPims(processos: ProcessoServico[]){
      return this.httpClient.post<Servico[]> (`${this.configService.getApiUrlRoot()}/servicos/pims`, processos)
  }
    
  enviarErp(corpo: any){
      return this.httpClient.post(`${this.configService.getApiUrlRoot()}/servicos/integracao`, corpo)
  }

  exportarServicos(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/servicos/relatorios/exportar`, corpo, { responseType: 'blob'})
  }

  cancelar(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/servicos/cancelar`, corpo)
  }

  estornar(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/servicos/estornar`, corpo)
  }

  buscarProcessos() {
    return this.httpClient.get<ProcessoServico[]> (`${this.configService.getApiUrlRoot()}/servicos/pims/processos`);
  }

  postCancelarEstornarServico(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/servicos/cancelar-estornar`, corpo)
  }
}
